import { TableProps } from 'antd/es/table';
import { Contact } from '../types';
import CugBadge from '../components/CugBadge';

export const createContactListColumns = (
  renderActionColumn: (text: string, record: unknown) => JSX.Element
): TableProps['columns'] => [
  {
    title: 'Employee Number',
    dataIndex: 'empNumber',
    key: 'empNumber',
    sorter: true,
    width: 150,
  },
  {
    title: 'Employee Name',
    dataIndex: 'empName',
    key: 'empName',
    sorter: true,
    width: 250,
  },
  {
    title: 'Occupation',
    dataIndex: 'occupation',
    key: 'occupation',
    sorter: true,
    width: 300,
  },
  {
    title: 'Employee Type',
    dataIndex: 'empType',
    key: 'empType',
    sorter: false, // Disabled sorting for Employee Type
    width: 150,
  },
  {
    title: 'Email',
    dataIndex: 'email1',
    key: 'email1',
    sorter: true,
    width: 250,
    render: (text: string | null) => text || '',
  },
  {
    title: 'Mobile',
    dataIndex: 'mobile1',
    key: 'mobile1',
    sorter: true,
    width: 150,
    render: (text: string, record: unknown) => {
      const contact = record as Contact;
      const mobile = text || '';
      const isCUG = contact?.mobile1CUG === 'True';
      return <CugBadge mobile={mobile} isCUG={isCUG} />;
    },
  },
  {
    title: 'Extension',
    dataIndex: 'extension',
    key: 'extension',
    sorter: true,
    width: 120,
    render: (text: string | null) => text || '',
  },
  {
    title: 'TA Number',
    dataIndex: 'tanumber',
    key: 'tanumber',
    sorter: true,
    width: 120,
    render: (text: string | null) => text || '',
  },
  {
    title: 'ACTION',
    dataIndex: 'action',
    key: 'action',
    width: 80,
    fixed: 'right',
    render: renderActionColumn,
  },
];
